import { call, select, put } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import pick from 'lodash/pick';


import * as selectors from '../selectors';
import * as c from '../constants';
import * as actions from '../actions';
import * as api from '../services';
import { saveDoc, deleteDoc } from '../../../../services/apiCommon';




export function* saveTemplate(feathersApp, data) {
  try {
    const { user = {} } = yield select();
    const { name, active } = data;
    const { id } = yield select(selectors.getTemplateState);

    const template = {
      id: data.id || id,
      name,
      active,
      doc_type: c.DOC_TYPE_HOTKEY_TEMPLATE
    };

    const opts = {
      user,
      source: data,
      doc: template,
    };
    
    return yield call(saveDoc, feathersApp, opts);
  } catch(err) {
    console.error('@saveTemplate: ', err.message || err);
    throw err;
  }
}




export function* saveTabAndChildren(feathersApp, tab) {
  try {
    const { id, key, key_level, level, deleted, is_default } = tab;

    if (key === c.ADD_DOC_ID) {
      return;
    }

    const children = yield select(selectors.getTabChildrenState, key_level);

    if (!id) {
      if (deleted) {
        return;
      }

      if (isEmpty(children)) {
        yield call(saveDefaultTemplateGroup, feathersApp, tab);
        return;
      }
    }

    const { items, initial_items } = children;

    const group = {
      ...tab,
      is_default: Boolean(is_default && isEqual(items, initial_items))
    };

    if (deleted) {
      yield call(deleteTemplateGroupRecursively, feathersApp, group, items);
    } else {
      yield call(saveTemplateGroup, feathersApp, group, items);
    }

    for (let cg of filter(items, { is_group: true })) {
      yield call(saveTabAndChildren, feathersApp, cg);
    }

    yield put(actions.markLevelSave(level));

  } catch(err) {
    console.error('@saveTabAndChildren: ', err.message || err);
    throw err;
  }
}




function* saveDefaultTemplateGroup(feathersApp, group) {
  yield call(saveTemplateGroup, feathersApp, group);
}




function* saveTemplateGroup(feathersApp, group, children) {
  const { user = {} } = yield select();
  const { id: hotkeyTemplateId } = yield select(selectors.getTemplateState);

  const template = buildTemplateGroup(group, children, hotkeyTemplateId);

  const source = group;
  addToRecord(source, 'id', template.id);

  const opts = {
    user,
    source: template,
    doc: template,
  }

  return yield call(saveDoc, feathersApp, opts);
}




function* deleteTemplateGroupRecursively(feathersApp, group) {
  const children = yield call(api.getTemplateChildrenGroup, feathersApp, group) || [];

  for (let cg of children) {
    yield call(deleteTemplateGroupRecursively, feathersApp, cg);
  }

  const opts = {
    id: group.id,
    docType: c.DOC_TYPE_HOTKEY_TEMPLATE_GROUP
  };

  return yield call(deleteDoc, feathersApp, opts);
}




function buildTemplateGroup(template, children, hotkeyTemplateId) {
  const {
    id,
    name,
    key,
    group_id,
    level,
    active,
    parent_id,
    position,
    is_group,
    is_class,
    key_level,
    image_url,
    is_default,
    breadcrumbs,
    hotkey_list,
    classification_id,
    is_template_group
  } = template;
  
  return {
    id,
    name,
    image_url,
    key,
    key_level,
    group_id,
    level,
    active,
    parent_id,
    position,
    is_group,
    is_class,
    is_default,
    breadcrumbs,
    classification_id,
    is_template_group,
    hotkey_list: buildHotkeyList(children || hotkey_list, is_default),
    doc_type: c.DOC_TYPE_HOTKEY_TEMPLATE_GROUP,
    parent_hotkey_template_id: hotkeyTemplateId
  };
}




function buildHotkeyList(list, isDefault = false) {
  if (isEmpty(list) || isDefault) {
    return null;
  }

  const newList = list.filter(({ disabled }) => !disabled);

  const ITEM_FIELDS = [
    'id',
    'active',
    'parent_id',
    'name',
    'is_class',
    'is_default',
    'is_group',
    'is_template_group',
    'group_id',
    'item_id',
    'position',
    'image_url',
    'key',
    'key_level',
    'level'
  ];
  const GROUP_FIELDS = [
    'id',
    'active',
    'name',
    'is_class',
    'is_group',
    'is_template_group'
  ];

  return reduce(newList, (res, l) => {
    return (l.key === c.ADD_DOC_ID)
      ? res
      : res.concat({
        ...pick(l, l.item_id ? ITEM_FIELDS : GROUP_FIELDS)
      });
  }, []);
}




function addToRecord(record, field, value) {
  if(value !== undefined && value !== null) {
    record[field] = value;
  }
}
